import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const { cinzaSebrae75, cinzaSebrae97 } = BaSeTheme.colors.institucionais;

export const WrapperDownloadFile = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 10px;
  cursor: pointer;
`;

export const WrapperReport = styled.div`
  display: ${({ isDesktop }) => (isDesktop ? 'flex' : 'grid')};
  padding: 16px;
  background: ${cinzaSebrae97};
  border: 1px solid ${cinzaSebrae75};
  border-radius: 3px;
  align-items: center;
  gap: 10px;
`;

export const ContentHeaderBox = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentCardReport = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;
`;
